import { render } from "./ImprestCreate.vue?vue&type=template&id=6c5a064e"
import script from "./ImprestCreate.vue?vue&type=script&lang=js"
export * from "./ImprestCreate.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__